export const DEFAULT_PANEL_WIDTH = 320;
export const DEFAULT_PANEL_HEIGHT = 400;
export const DEFAULT_PANEL_MAX_WIDTH = 500;
export const DEFAULT_PANEL_MAX_HEIGHT = 500;
export const PANEL_HEADER_HEIGHT = 24;
export const PANEL_HEADER_HEIGHT_PADDED = PANEL_HEADER_HEIGHT + 2;
